import React from 'react';
import checkmark1Icon from '../../../assets/img/checkmark1.png';

export const QuickSearchBadge = (props) => {
  if (props.quickSearchSelected) {
    return (
      <span className="quickSearchBadgeSelected" onClick={props.onClick}>
        <img
          src={checkmark1Icon}
          alt="checkMark.png"
          style={{ marginRight: '5px', height: '9px', width: '11px' }}
        />
        {props.text}
      </span>
    );
  } else {
    return (
      <span className="quickSearchBadge" onClick={props.onClick}>
        {props.text}
      </span>
    );
  }
};
